import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/FusionSkinSection.css';

const FusionSkinSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="fusion-skin-section">
      <div className="fusion-skin-content">
        <div className="fusion-skin-text">
          <h2 className="fusion-skin-title">{t('fashion.fashionSkin')}</h2>
          <p className="fusion-skin-subtitle">{t('fashion.everyBoboUnique')}</p>
        </div>
        <div className="fusion-skin-image-container">
          <img src="/images/page14.png" alt="BOBO character" className="fusion-skin-image" />
        </div>
      </div>
    </section>
  );
};

export default FusionSkinSection; 